<template>
  <div class="phone-div">
    <van-field
      v-model="phone"
      placeholder="请输入手机号"
      clearable
    >
    </van-field>

    <van-field
      v-model="code"
      placeholder="请输入验证码"
      type="tel"
      clearable
    >
      <van-button slot="button" class="send-btn" size="small" type="primary" :disabled="sendDisabled" @click="sendCode">
        {{ sendText }}
      </van-button>
    </van-field>

    <van-button class="btn" @click="submit">确 定</van-button>
  </div>
</template>

<script>
import { replaceUserPhoneSendCode, replaceUserPhoneVerify } from '@/api/mine'
import { isMobile, isSmsCode } from '@/utils/tool'
import { Toast } from 'vant'
import { getAccountId } from '@/utils/auth'

export default {
  data() {
    return {
      accountId: getAccountId(),
      phone: '',
      code: '',
      sendDisabled: false,
      sendText: '获取验证码'
    }
  },
  methods: {
    sendCode: function() {
      if (!isMobile(this.phone)) {
        return Toast({
          message: '手机号格式错误',
          duration: 1500
        })
      }
      this.updateSendBtn()
      this.sendReplaceMsg()
    },
    updateSendBtn: function(timeout = 59) {
      this.sendText = `${timeout}s`
      this.sendDisabled = true
      setTimeout(() => {
        if (timeout > 1) {
          this.updateSendBtn(--timeout)
        } else {
          this.sendDisabled = false
          this.sendText = '获取验证码'
        }
      }, 1000)
    },
    sendReplaceMsg: function() {
      replaceUserPhoneSendCode({ phone: this.phone }).then(res => {})
    },
    submit: function() {
      var this_ = this
      if (!isMobile(this.phone)) {
        return Toast({
          message: '手机号格式错误',
          duration: 1500
        })
      }
      if (!isSmsCode(this.code)) {
        return Toast({
          message: '验证码格式错误',
          duration: 1500
        })
      }
      replaceUserPhoneVerify({
        accountId: this.accountId,
        phone: this.phone,
        code: this.code
      }).then(res => {
        if (res && res.data.code === 0) {
          this_.$router.push('/edit/user/set')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .phone-div{
    height: 95px;
    background-color: white;
    margin-top: 3.5px;
  }
  .van-button--primary {
    color: #F18937;
    border: 1px solid #F18937;
    background-color: #fff;
    border-radius:5px;
  }
  .btn {
    width: 92%;
    margin: 30px 4% 0;
    background: #F18937;
    color: #fff;
    border-radius:22px;
    font-size: 18px;
  }
</style>

